export class CredentialsTypes {
	static ClientId = "neomode";
	static ClientSecret = "eyJhbGcJhGTSUzI1NiIsImtpZCI6IjBiZTg5Y";
	static GrantTypeCredentials = "client_credentials";
	static GrantTypePassword = "password";
	static Scope = "lori";
}
